module.exports = __webpack_public_path__ + "img/icon-actividad.02d4c813.svg";